import { Backdrop, CircularProgress } from "@mui/material";
import { SEO, OrgTree } from "components";
import { i18n } from "translations";
import { BasePageProps } from "utils";

import { useOrganizationalChart } from "./hooks";
import { DepartmentDialog, EmployeeDialog } from "./Sections";

const OrganizationalChart: React.FC<BasePageProps> = () => {
  const {
    orgChart,
    dialog,
    actions,
    orgName,
    transformComponentRef,
    isFetched,
    isLoading,
  } = useOrganizationalChart();
  return (
    <>
      <SEO
        title={i18n.t("organizationChart")}
        description="Talentnet User Management System"
        keywords="Talentnet"
      />
      {dialog.department.show && (
        <DepartmentDialog
          isEdit={dialog.department.isEdit}
          show={dialog.department.show}
          onToggle={dialog.department.onToggle}
        />
      )}
      {dialog.employee.show && (
        <EmployeeDialog
          show={dialog.employee.show}
          onToggle={dialog.employee.onToggle}
        />
      )}
      <div
        style={{
          width: "100%",
          height: "100%",
          position: "relative",
        }}
      >
        <Backdrop
          sx={{ color: "#fff", zIndex: (theme) => theme.zIndex.drawer + 1 }}
          open={isLoading}
        >
          <CircularProgress color="inherit" />
        </Backdrop>
        {isFetched && (
          <OrgTree
            title={i18n.t("organizationChart")}
            orgChart={orgChart}
            orgName={orgName}
            actions={{
              onClickNode: actions.handleClickNode,
            }}
            transformRef={transformComponentRef}
          />
        )}
        {/* {isLoading && (
          <Stack position="absolute" top="50%" left="50%">
            <CircularProgress />
          </Stack>
        )} */}
      </div>
    </>
  );
};

export default OrganizationalChart;
